/* ==========================================================================
   nq-cart-drawer.js — Cart drawer Noa Miller
   1) Temporizador de reserva (persiste en sessionStorage por sesion)
   2) Botones "+ Add" del carrusel de upsells
   Todo por delegacion en document: el drawer se re-renderiza entero desde el
   servidor en cada cambio de carrito, asi que no se puede atar nada al DOM.
   ========================================================================== */
(function () {
  if (window.__nqCartDrawerInit) return;
  window.__nqCartDrawerInit = true;

  var STORAGE_KEY = 'nqcdReserveDeadline';

  /* ----------------------------- timer ----------------------------------- */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function deadline(minutes) {
    var stored = null;
    try {
      stored = window.sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      stored = null;
    }
    var value = stored ? parseInt(stored, 10) : NaN;
    if (!value || isNaN(value) || value <= Date.now()) {
      value = Date.now() + minutes * 60 * 1000;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, String(value));
      } catch (e) {
        /* modo privado: el timer arranca de cero en cada render */
      }
    }
    return value;
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-nqcd-timer]');
    if (!nodes.length) return;
    var minutes = parseInt(nodes[0].getAttribute('data-nqcd-minutes'), 10) || 10;
    var left = Math.max(0, deadline(minutes) - Date.now());
    var total = Math.floor(left / 1000);
    var text = pad(Math.floor(total / 60)) + ':' + pad(total % 60);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
  }

  tick();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, tick);
  }

  /* ---------------------------- upsells ---------------------------------- */
  function fetchOpts(body) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    };
  }

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-nqcd-add]') : null;
    if (!button) return;

    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    var card = button.closest('.nqcd__card');
    var picker = card ? card.querySelector('.nqcd__card-variant') : null;
    var variantId = (picker && picker.value) || button.getAttribute('data-nqcd-add');
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    var label = button.textContent;
    button.classList.add('is-loading');

    fetch(
      addUrl(),
      fetchOpts({
        items: [{ id: Number(variantId), quantity: 1 }],
      })
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (added) {
        if (added.status) return added;
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function () {
            return fetch(
              '/cart?sections=cart-drawer,cart-icon-bubble',
              { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
            );
          })
          .then(function (r) {
            return r.json();
          })
          .then(function (sections) {
            return { sections: sections };
          });
      })
      .then(function (parsed) {
        if (parsed.status) {
          button.textContent = parsed.description || parsed.message || label;
          setTimeout(function () {
            button.textContent = label;
            button.classList.remove('is-loading');
          }, 2500);
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function' && parsed.sections) {
          drawer.renderContents(parsed);
        } else {
          window.location.reload();
          return;
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'nq-cart-drawer-upsell',
            productVariantId: variantId,
          });
        }
      })
      .catch(function (error) {
        console.error('[nq-cart-drawer]', error);
        button.classList.remove('is-loading');
        button.textContent = label;
      });
  });
})();